import React, { useEffect, useState } from "react";

import {
  createDefaultImageryProviderViewModels,
  IonImageryProvider,
  OpenStreetMapImageryProvider,
  UrlTemplateImageryProvider,
} from "cesium";

import styled from "styled-components";

const ImageProviderDropdownContainer = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.h4`
  color: "#fff";
  margin-bottom: "10px";
  font-size: "14px";
  margin-bottom: 10px;
`;

const DropdownContainer = styled.div`
  position: relative;
`;

const DropdownButton = styled.button`
  padding: 10px 16px;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  /* min-width: 150px; */
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: rgba(38, 38, 38, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  margin-top: 2px;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
`;

const DropdownItem = styled.div`
  padding: 10px 16px;
  font-size: 15px;
  color: #fff;
  cursor: pointer;
  border-bottom: ${(props) =>
    props.$isLast ? "none" : "1px solid rgba(255, 255, 255, 0.1)"};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const ArrowIcon = styled.span`
  font-size: 10px;
`;

export default function ImageProviderDropdown() {
  // state 추가
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [imageryProviders, setImageryProviders] = useState([]);

  const wanted = [
    "Bing Maps Aerial",
    "Stadia Alidade Smooth",
    "Stadia Alidade Smooth Dark",
    "Open­Street­Map",
    "Bing Maps Roads",
  ];
  const mapName = {
    "Bing Maps Aerial": "항공 사진",
    "Bing Maps Roads": "도로 지도",
    "Stadia Alidade Smooth": "일반 지도",
    "Stadia Alidade Smooth Dark": "일반 지도 다크",
    "Open­Street­Map": "오픈 스트리트 지도",
  };

  // 이미지 제공자 초기화
  useEffect(() => {
    const initializeImageryProviders = () => {
      try {
        const allImageryVMs = createDefaultImageryProviderViewModels();

        // 필터링된 이미지 제공자들 (일부만 선택)
        const filteredProviders = allImageryVMs.filter((vm) => {
          return wanted.includes(vm.name);
        });
        setImageryProviders(filteredProviders);
      } catch (error) {
        console.error("이미지 제공자 초기화 실패:", error);
      }
    };

    initializeImageryProviders();
  }, []);

  // 외부 클릭 시 드롭다운 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest(".dropdown-container")) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  // 이미지 제공자 전환 함수
  const switchImageProvider = (providerViewModel) => {
    // CesiumJS 컴포넌트의 viewer에 접근하여 이미지 제공자 변경
    const viewer = window.cesiumViewer; // CesiumJS에서 전역으로 설정된 viewer 참조

    if (viewer && providerViewModel) {
      try {
        viewer.baseLayerPicker._viewModel.selectedImagery = providerViewModel;
      } catch (error) {
        console.error("이미지 제공자 변경 실패:", error);
      }
    }
  };

  // 드롭다운 토글 함수
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // 이미지 제공자 선택 함수
  const selectProvider = (provider) => {
    setSelectedProvider(provider);
    setIsDropdownOpen(false);
    switchImageProvider(provider);
  };

  return (
    <ImageProviderDropdownContainer>
      <Title>지도 타입</Title>

      <DropdownContainer className="dropdown-container">
        <DropdownButton onClick={toggleDropdown}>
          <span>
            {selectedProvider
              ? mapName[selectedProvider.name]
              : "지도 타입 선택"}
          </span>
          <ArrowIcon>{isDropdownOpen ? "▲" : "▼"}</ArrowIcon>
        </DropdownButton>

        {isDropdownOpen && (
          <DropdownMenu>
            {imageryProviders.map((provider, index) => (
              <DropdownItem
                key={index}
                onClick={() => selectProvider(provider)}
                $isLast={index === imageryProviders.length - 1}
              >
                {mapName[provider.name]}
              </DropdownItem>
            ))}
          </DropdownMenu>
        )}
      </DropdownContainer>
    </ImageProviderDropdownContainer>
  );
}
